/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDataTenantDto } from '../../models/paginated-data-tenant-dto';

export interface FindTenants$Params {
  searchStr?: string;
  pageNumber?: number;
  count?: number;
  withInactive?: boolean;
}

export function findTenants(http: HttpClient, rootUrl: string, params?: FindTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataTenantDto>> {
  const rb = new RequestBuilder(rootUrl, findTenants.PATH, 'get');
  if (params) {
    rb.query('searchStr', params.searchStr, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('count', params.count, {});
    rb.query('withInactive', params.withInactive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDataTenantDto>;
    })
  );
}

findTenants.PATH = '/api/tenants';
